import React, { Component, Fragment } from 'react';
import { Select } from 'antd';
import { YMaps } from 'react-yandex-maps';

const { Option } = Select;

let timeout;
let currentValue;

class SearchMapInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      value: undefined,
      ymaps: false,
      initialValue: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { value } = props;
    if (props) {
      state = { initialValue: value };
    }
    return state;
  }

  fetch = (value, callback, ymaps) => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    currentValue = value;

    timeout = setTimeout(() => {
      ymaps.suggest(currentValue).then(items => {
        const data = [];
        items.forEach(item => {
          data.push({
            value: item.value,
            text: item.displayName,
          });
        });

        callback(data);
      });
    }, 300);
  };

  handleChange = value => {
    if (value && value.length) {
      // Надо решить что делать с этими комментариями. Из-за утечка памяти с ворнингом происходит.
      this.fetch(value, data => this.setState({ data }), this.state.ymaps);
    } else {
      this.setState({ data: [] });
    }
  };

  initYmaps = ymaps => {
    this.setState(() => ({
      ymaps: ymaps,
    }));
  };

  onChange = value => {
    if (value && value.length && this.state.ymaps) {
      this.state.ymaps.geocode(value, { results: 1 }).then(res => {
        let itemValue = this.state.data.find(item => item.value === value);
        this.props.handleChange(
          Number(this.props.routeIndex),
          itemValue,
          res.geoObjects.get(0).geometry.getCoordinates()
        );
      });
    } else {
      this.props.handleChange(Number(this.props.routeIndex), null, null);
    }
  };

  render() {
    return (
      <Fragment>
        <Select
          {...this.props}
          autoComplete={this.props.autoComplete}
          style={this.props.style}
          placeholder={this.props.placeholder}
          showSearch
          disabled={this.props.disabled}
          defaultActiveFirstOption={false}
          showArrow={false}
          filterOption={false}
          onChange={this.onChange}
          onSearch={this.handleChange}
          notFoundContent={null}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {this.state.data.map(item => (
            <Option key={item.value}>{item.text}</Option>
          ))}
        </Select>
        <YMaps
          query={{
            apikey: 'b6a66b8f-dc2c-4946-a916-0fb0ca680e5a',
          }}
          onApiAvaliable={ymaps => this.initYmaps(ymaps)}
        />
      </Fragment>
    );
  }
}

export default SearchMapInput;